import type { UsUser } from '@shared/graphql';

export interface SessionInfo {
  scopes: string[];
  ttl: number;
  twoFactorStatus: string;
  email: string;
}

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  isVerified: boolean;
  appRoles: string[];
  // TODO: implement shared userStatus constant
  status: string;
  isAdmin?: boolean;
}

export function mapUserProfile(profileData: UsUser): UserProfile {
  const { id, firstname, lastname, email, isVerified, appRoles, status, isAdmin } =
    profileData ?? {};

  return {
    id,
    firstName: firstname,
    lastName: lastname,
    displayName: `${firstname} ${lastname}`,
    email: email ?? '',
    isVerified: !!isVerified,
    appRoles: appRoles ?? [],
    status: status ?? '',
    isAdmin: isAdmin ?? false,
  };
}
